import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ConfigService } from '@app/core/services/config.service';
import { UsersService } from '@app/core/services/users.service';
import { GlobalConstants } from '@app/portal/global-constants';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-footer-public',
  templateUrl: './footer-public.component.html'
})

export class FooterPublicComponent {
  appTitle = GlobalConstants.appInfo.appTitle;
  appYear: number = new Date().getFullYear();
  appVersion?: string;

  constructor(private configService: ConfigService, private httpClient: HttpClient,
    private usersService: UsersService) {
    let publicPath = this.configService.appConfig.apic.baseUrl + this.configService.appConfig.apic.apiPath + this.configService.appConfig.api.baseUrl;
    this.usersService.pubtk().then(r => {
      firstValueFrom(this.httpClient.get<any>(`${publicPath}/version`))
        .then(response =>
          this.appVersion = response.version);
    });
  }
}
